import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = () => {
  const location = useLocation();
  
  const pathMap = {
    '/dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/master-data-management': { label: 'Master Data Management', icon: 'Database' },
    '/production-workflow': { label: 'Production Workflow', icon: 'Factory' },
    '/inventory-management': { label: 'Inventory Management', icon: 'Package' },
    '/invoice-challan-management': { label: 'Invoice & Challan Management', icon: 'FileText' },
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs = [{ label: 'Home', path: '/dashboard', icon: 'Home' }];
    
    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const pathInfo = pathMap[currentPath];
      
      if (pathInfo) {
        breadcrumbs.push({
          label: pathInfo.label,
          path: currentPath,
          icon: pathInfo.icon,
          isLast: index === pathSegments.length - 1
        });
      }
    });

    // Remove duplicate home if current path is dashboard
    if (location.pathname === '/dashboard') {
      return [{ label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard', isLast: true }];
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigation = (path) => {
    if (path !== location.pathname) {
      window.location.href = path;
    }
  };

  if (location.pathname === '/login') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm mb-6" aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.path} className="flex items-center">
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="mx-2 text-muted-foreground" 
            />
          )}
          
          {crumb.isLast ? (
            <div className="flex items-center space-x-2 px-2 py-1 bg-muted/50 rounded-md">
              <Icon 
                name={crumb.icon} 
                size={16} 
                className="text-primary" 
              />
              <span className="font-medium text-foreground">{crumb.label}</span>
            </div>
          ) : (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleNavigation(crumb.path)}
              className="px-2 py-1 h-auto text-muted-foreground hover:text-foreground transition-smooth"
            >
              <Icon 
                name={crumb.icon} 
                size={16} 
                className="mr-2" 
              />
              {crumb.label}
            </Button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;